export const socialsData = {
    github: 'https://github.com/ahanban15',
    facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/ahan-bandyopadhyay-b30520222/',
    instagram: 'https://www.instagram.com/',
    codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/itsbandyahan',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/'
}